export default class HydratorError extends Error {
  constructor({
    error,
    message
  }) {
    super();
    const err = error instanceof Error ? error : new Error();
    this.name = 'HydratorError';
    this.message = message;
    this.originalMessage = err.message;
    this.stack = err.stack;
    this.originalName = err.name;
  }
}